module.exports = __webpack_public_path__ + "03_veryshort_gray.c3e0ee06.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_veryshort_gray.png
// module id = DVbG
// module chunks = 0